"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFromSessionStorage = loadFromSessionStorage;
exports.removeSessionStorage = removeSessionStorage;
exports.saveToSessionStorage = saveToSessionStorage;
exports.storageSession = storageSession;
var _log = require("../utils/log");
// key needed for log functionality used if appName is not provided
const storageKey = 'storageSession';

/**
 * Function will return parsed serialized data from session storage based on name
 * In case of error, error is written to console and undefined is returned.
 * @param name Session storage name
 * @param fallback Value in case the session storage item is not defined or some error occurs
 * @param appName Application name / logger key
 * @returns Parsed, serialized value from session storage, null or undefined
 */
function loadFromSessionStorage(name, fallback, appName) {
  try {
    const serializedData = sessionStorage.getItem(name);
    (0, _log.log)(appName ?? storageKey, 4, `📦 Session->load->${name} | fallback: ${JSON.stringify(fallback)} | serializedData: ${serializedData}`);
    let returnValue = fallback;
    if (serializedData) {
      returnValue = JSON.parse(serializedData) ?? null;
    }
    return returnValue;
  } catch (error) {
    (0, _log.log)(appName ?? storageKey, 1, `📦 Session->load->${name}`, error);
    return undefined;
  }
}

/**
 * Function will stringify value and store it into the session storage with a key: name.
 * In case of error, error is written to console.
 * @param name Local storage name
 * @param value Value we want to store into session storage
 * @param appName Application name / logger key
 */
function saveToSessionStorage(name, value, appName) {
  try {
    (0, _log.log)(appName ?? storageKey, 4, `📦 Session->save->${name} | value: ${JSON.stringify(value)}`);
    let serializedData = '';
    serializedData = JSON.stringify(value);
    sessionStorage.setItem(name, serializedData);
  } catch (error) {
    (0, _log.log)(appName ?? storageKey, 1, `📦 Session->save->${name}`, error);
  }
}

/**
 * Function will remove record from the session storage based on name
 * In case of error, error is written to console.
 * @param name Session storage name
 * @param appName Application name / logger key
 */
function removeSessionStorage(name, appName) {
  try {
    (0, _log.log)(appName ?? storageKey, 4, `📦 Session->remove->${name}`);
    sessionStorage.removeItem(name);
  } catch (error) {
    (0, _log.log)(appName ?? storageKey, 1, `📦 Session->remove->${name}`, error);
  }
}

/**
 * Function will return functions for working with session storage
 * @param appName Application name / logger key
 * @returns Functions for working with session storage
 */
function storageSession(appName) {
  return {
    loadSession: (name, fallback) => loadFromSessionStorage(name, fallback, appName),
    saveSession: (name, value) => saveToSessionStorage(name, value, appName),
    removeSession: name => removeSessionStorage(name, appName)
  };
}
